// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na[data-v-0de1aee2] {\n    color: var(--green-color);\n}\n.table thead th[data-v-0de1aee2] {\n    background: #e4e6e8;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 12px;\n    color: var(--grey-color);\n}\n.table tbody td[data-v-0de1aee2] {\n    font-size: 14px;\n    /*font-weight: 600;*/\n    padding: 12px;\n    border-bottom: 1px solid #dee2e6;\n    color: var(--grey-color);\n}\n", ""]);
// Exports
module.exports = exports;
